export type Validator = (value: string) => boolean;
